var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneHeaderLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7013,
    cy: 13.2407,
    r: 12.8438,
    fill: "#F3F2E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7013 8.1709C11.4649 8.1709 9.6453 9.9905 9.6453 12.2243C9.6306 15.4919 13.5471 18.2013 13.7013 18.3108C13.7013 18.3108 17.7719 15.4919 17.7572 12.2268C17.7572 9.9905 15.9376 8.1709 13.7013 8.1709ZM13.7013 14.2548C12.5808 14.2548 11.6733 13.3473 11.6733 12.2268C11.6733 11.1064 12.5808 10.1989 13.7013 10.1989C14.8217 10.1989 15.7292 11.1064 15.7292 12.2268C15.7292 13.3473 14.8217 14.2548 13.7013 14.2548Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneHeaderLocation);
export default __webpack_public_path__ + "static/media/phone-header-location.43f9d2d704eba89970e879fb4ae85a69.svg";
export { ForwardRef as ReactComponent };